'use client';

import { cn, TOverlayContainerProps } from 'types';

export const OverlayContainer = ({
  children,
  className,
  zIndex = 99,
  overlayBgColor,
  clearOverlay = false,
}: Partial<TOverlayContainerProps>) => {
  return (
    <div
      style={{
        zIndex,
        background: clearOverlay ? 'transparent' : overlayBgColor || 'var(--color-pureBlack80)',
      }}
      className={cn('fixed inset-0 flex items-center justify-center', className)}
    >
      {children}
    </div>
  );
};
